import React from "react";
import HighlightsImg from "./highlight.png";
export default function Highlights(props) {
  return (
    <div>
      <img src={HighlightsImg} alt="" />
    </div>
  );
}
